// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1ir3kb7n input::-ms-input-placeholder{opacity:1}\n._1ir3kb7n input::placeholder{opacity:1}\n._5ce6131l input::-ms-input-placeholder{color:var(--ds-text-subtlest,#626f86)}\n._5ce6131l input::placeholder{color:var(--ds-text-subtlest,#626f86)}\n._h5gq131l input:-ms-input-placeholder{color:var(--ds-text-subtlest,#626f86)}", ""]);
// Exports
module.exports = exports;
